import { ButtonConfig, DataGridFeatureConfig } from '@waseel-asp/tpa-waseel-lib-staging';
import { GRID_PAGE_DEFAULT_SIZE } from "../../../../../../shared/constants/grid-constant";
import { IBeneficiaryDocument } from "../../../beneficiary/models/beneficiary.model";
import { INphiesError } from "../../../../../../shared/models/nphies-error.model";
import { INetworkDetails } from "../../../configuration/networks/models/networks.model";

export interface IEligibility {
  eligibilityRequestId: string;
  eligibilityId: string;
  beneficiaryId: string,
  beneficiaryFullName: string,
  isEmergency: boolean,
  isReferral: boolean,
  isNewborn: boolean,
  serviceDate: string,
  isBenefits: boolean,
  isDiscovery: boolean,
  isValidation: boolean,
  payerNameEnglish: string,
  payerNameArabic: string,
  processStatusNameEnglish: string,
  processStatusNameArabic: string,
  disposition: string,
  responseIdentifierUrl: string,
  responseIdentifierValue: string,
  tpaNameEnglish: string,
  tpaNameArabic: string,
  statusNameEnglish: string,
  statusNameArabic: string,
  eligibilityCoverages: eligibilityCoverages[],
  eligibilityErrors: eligibilityErrors[],
  nphiesValidationErrors: INphiesError[],
  beneficiaryDocuments: IBeneficiaryDocument[];
}

interface eligibilityCoverages {
  inForce: string,
  policyStartDate: Date,
  policyEndDate: Date,
  memberId: string,
  policyNumber: string,
  policyGroupName: string,
  policyHolder: string,
  policyId: string,
  coverageType: string,
  coverageTypeNameEnglish: string,
  coverageTypeNameArabic: string,
  policyStatusNameEnglish: string,
  policyStatusNameArabic: string,
  eligibilityPolicyStatusNameEnglish: string,
  eligibilityPolicyStatusNameArabic: string,
  relationWithSubscriberNameEnglish: string,
  relationWithSubscriberNameArabic: string,
  eligibilityPolicyClasses: eligibilityPolicyClasses[],
}

export interface eligibilityPolicyClasses {
  classId: string,
  classNameEnglish: string,
  classNameArabic: string,
  networkDetails: INetworkDetails[],
  minPatientShare: string,
  maxPatientShare: string,
  subrogation: string,
  eligibilityBenefits: eligibilityBenefits[]
}

export interface eligibilityBenefits {
  benefitId: string,
  benefitNameEnglish: string,
  benefitNameArabic: string,
  eligibilityBenefitDetails: eligibilityBenefitDetails[]
}

interface eligibilityBenefitDetails {
  benefitCode: string,
  benefitNameEnglish: string,
  benefitNameArabic: string,
  benefitDescriptionEnglish: string,
  benefitDescriptionArabic: string,
  caseTypeId: string,
  caseTypeNameEnglish: string,
  caseTypeNameArabic: string,
  caseType: string,
  termNameEnglish: string,
  termNameArabic: string,
  networkTypeNameEnglish: string,
  networkTypeNameArabic: string,
  unitNameEnglish: string,
  unitNameArabic: string,
  benefitLimit: number,
  benefitThresholdLimit: number,
  copartPercentage: number,
  copartMin: number,
  copartMax: number,
  patientShare: number,
  maxPatientShare: number;
  maxConsultationFee: number;
  deductible: string,
  visit: string,
  roomTypeNameArabic: string,
  roomTypeNameEnglish: string,
  visionExam: string,
  visionGlasses: string,
  visionContacts: string,
  medicalPrimaryCare: string,
  pharmacyDispense: string
}

export interface eligibilityErrors {
  eligibilityErrorId: string,
  code: string,
  message: string
}

export const gridFeatures: DataGridFeatureConfig<any> = {
  isRowHoverEnable: true,
  showPagination: false,
  enableApiSearching: false,
  enableApiSorting: false,
  allowSearching: false,
  allowSorting: false,
  allowHideShowColumns: true,
  allowExpandRow: false,
  showCheckboxSelection: false,
  stickyFeature: {
    isStickyHeader: true
  },
  paginatorFeatures: {
    defaultPagesize: GRID_PAGE_DEFAULT_SIZE,
    totalCount: 0,
    currentPageIndex: 0,
    enableApiPagination: false,
    showRefreshButton: false,
  }
};

export interface MenuConfig {
  title: string;
  iconUrl: string;
  tooltipText: string;
  buttonConfig: ButtonConfig[];
}
